export const TimeSlots = ({timeSlots, zoomInOut, textColor}) => {
    return (
        <div className="time-slots-container col-2 px-2 text-center" style={{color: textColor}}>
            {timeSlots?.map((slot, index) => (
                <div 
                    key={index}
                    style={{ width: "100%", height: `${30 * zoomInOut}px` }}
                    className="time-slot"
                >
                    <p>{slot}</p>  {/* Customize this to display relevant time slot info */}
                </div>
            ))}
        </div>
    )
}